import React, { useEffect, useState } from 'react';
import { Collapse, IconButton, Tooltip as MuiTooltip } from '@mui/material';
import { useSearchStatementContext } from './search-statement-context';
import Tooltip from '../../../lib/tooltip/Tooltip';
import ConditionBuilder from './ConditionBuilder';
import WarningIcon from '../../../assets/warning-sign-24px.png';
import EntityDialogSectionHeader from '../../EntityDialogSectionHeader';
import { Logger } from '@elyx-code/common-ts-utils';

const FilterConditionsSection = ({}: {}) => {
	const {
		searchStatementState,
		where,
		setWhere,
		entity,
		whereUpdateKey,
		mainDataSource,
		hydrationReady
	} = useSearchStatementContext();

	const [sectionOpen, setSectionOpen] = useState(null);

	useEffect(() => {
		if (hydrationReady) {
			setSectionOpen(!!searchStatementState.where && !!mainDataSource);
		}
	}, [hydrationReady]);

	return (
		<section
			key={whereUpdateKey}
			style={{
				display: 'flex',
				flexDirection: 'column',
				paddingBottom: sectionOpen ? 20 : 0,
				width: '100%',
				boxSizing: 'border-box'
			}}
		>
			<EntityDialogSectionHeader
				title="Filter conditions"
				subtitle="Add conditions to filter which entries are selected."
				hideShowSuffix="the filter section"
				open={sectionOpen}
				onToggle={() => setSectionOpen(!sectionOpen)}
				headerEndIcon={
					!mainDataSource &&
					!!where && (
						<MuiTooltip
							placement="bottom"
							enterDelay={0}
							leaveDelay={200}
							arrow
							title={
								<>
									Select a data source to filter entries based
									on conditions
									<br />
									<br />
									Existing conditions will be ignored in the
									final results, until a data source is
									selected
								</>
							}
						>
							<img
								className="search-statement__error-icon"
								id={`all-aggregations--error-icon`}
								src={WarningIcon}
							/>
						</MuiTooltip>
					)
				}
				headerStartIcon={
					!!where && (
						<>
							<IconButton
								id="search-statement-dialog-remove-filter-button"
								aria-label="delete"
								size="small"
								disabled={!entity.editable}
								onClick={() => {
									setWhere(null);
								}}
								style={{
									width: 30,
									height: 30,
									fontSize: 18,
									color: '#F65858'
								}}
							>
								<i className="fa-regular fa-trash" />
							</IconButton>
							<Tooltip
								anchorQuerySelector="#search-statement-dialog-remove-filter-button"
								placement="bottom"
								openDelay={300}
							>
								Delete filters to select entries in the data
								source only based on order
							</Tooltip>
						</>
					)
				}
			/>

			<Collapse in={sectionOpen}>
				<div
					style={{
						marginTop: 6,
						display: 'flex',
						flexDirection: 'column',
						gap: 4,
						marginLeft: 80,
						overflowX: 'auto',
						paddingRight: 40,
						paddingBottom: 20
					}}
				>
					<h3 style={{ margin: 0, fontSize: 12, fontWeight: 500 }}>
						Condition
					</h3>
					<p
						style={{
							margin: 0,
							fontSize: 10,
							color: 'rgba(0,0,0,0.54)'
						}}
					>
						Select all entries where the condition matches
					</p>

					<br className="quarter-space" />

					<ConditionBuilder
						condition={where}
						options={[
							...entity.inputs,
							...searchStatementState.columns
						]}
						onChange={(updatedWhere) => {
							Logger.log('Updated top condition', updatedWhere);
							setWhere(updatedWhere);
						}}
					/>
				</div>
			</Collapse>
		</section>
	);
};

export default FilterConditionsSection;
